var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import CoveragesCtrl from '../common/coveragesCtrl';

var AdditionalCoveragesCtrl = function (_CoveragesCtrl) {
    _inherits(AdditionalCoveragesCtrl, _CoveragesCtrl);

    function AdditionalCoveragesCtrl() {
        _classCallCheck(this, AdditionalCoveragesCtrl);

        return _possibleConstructorReturn(this, (AdditionalCoveragesCtrl.__proto__ || Object.getPrototypeOf(AdditionalCoveragesCtrl)).apply(this, arguments));
    }

    _createClass(AdditionalCoveragesCtrl, [{
        key: 'setCoverages',
        value: function setCoverages(updateCoverage, updatedCoverages) {
            this.CoveragesUtil.updateCoverages(updateCoverage, updatedCoverages.additionalCoverages, this.coverages.value.additionalCoverages);
        }
    }]);

    return AdditionalCoveragesCtrl;
}(CoveragesCtrl);

export default AdditionalCoveragesCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-bop-components-angular/coverages/additional/additionalCoveragesCtrl.js
// module id = 1801
// module chunks = 0